export default "__VITE_ASSET__Lo0wAUGA__"